import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {DownloadService} from "../../../service/download.service";
import {BatchDownload} from "../../../model/batchDownload";
import {HttpEventType, HttpResponse} from "@angular/common/http";

@Component({
  selector: 'app-download-page',
  templateUrl: './download-page.component.html',
  styleUrls: ['./download-page.component.css']
})
export class DownloadPageComponent implements OnInit {

  batchDownload: BatchDownload;
  errorWhileLoading: boolean = false;
  loadingBatchDownload: boolean = true;
  timeDifference;
  progress = 0;
  downloading: boolean = false;

  constructor(private route: ActivatedRoute, private downloadService: DownloadService) {
  }

  ngOnInit(): void {
    let batchDownloadId = this.route.snapshot.params.downloadid;

    this.downloadService.getBatchDownload(batchDownloadId).subscribe({
      next: (batchDownload) => {
        this.batchDownload = batchDownload;
        this.timeDifference = this.calculateTimeDifference();
        this.downloading = this.isDateExpired();
        this.errorWhileLoading = false;
        this.loadingBatchDownload = false;
      },
      error: () => {
        this.errorWhileLoading = true;
        this.loadingBatchDownload = false;
      }
    })
  }
  downloadBatchFile(id: string): void {
    this.downloading = true;
    this.progress = 0;
    this.downloadService.downloadBatchFile(id).subscribe(event => {
      if (event.type === HttpEventType.DownloadProgress) {
        if (event.total) {
          this.progress = Math.round(100 * event.loaded / event.total);
        }
      } else if (event instanceof HttpResponse) {
        const blob = new Blob([event.body], { type: event.body.type });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Dokumente.zip';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      }

      if(this.progress === 100){
        this.downloading = false;
      }
    });
  }

  calculateTimeDifference() {
    return (new Date(this.batchDownload.expirationDate).getTime() - new Date().getTime());
  }

  /**
   * Determines if the date of the current batch download is expired by comparing it do the current date
   *
   * @return true If the batch download expiration date is less than the current date time, else fale
   */
  public isDateExpired(): boolean{
    return new Date(this.batchDownload.expirationDate).getTime() < new Date().getTime();
  }

}
